const baseColors = [
  "#ff7675",
  "#a29bfe",
  "#6c5ce7",
  "#ffeaa7",
  "#0984e3",
  "#55efc4",
  "#fab1a0",
  "#fd79a8",
  "#74b9ff",
  "#fdcb6e",
  "#00b894",
  "#e17055",
  "#81ecec",
  "#d63031",
  "#00cec9",
  "#e84393",
  "#b2bec3",
];

const userColorMap = new Map();
let assignedCount = 0;

export function avatarColors(userId) {
  if (userColorMap.has(userId)) return userColorMap.get(userId);

  const color = baseColors[assignedCount % baseColors.length];
  userColorMap.set(userId, color);
  assignedCount++;
  return color;
}
